import React, { useState } from 'react';
import { Button } from './ui/button';
import { ArrowRight, TrendingUp, DollarSign } from 'lucide-react';

const Hero = () => {
  const [activeTab, setActiveTab] = useState('auction');

  const handleContact = () => {
    window.open('https://t.me/darkerthandeath', '_blank');
  };

  const scrollToServices = () => {
    const element = document.getElementById('services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Animated Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a0e1a] via-[#0f1420] to-[#0a0e1a]">
        <div className="absolute inset-0 opacity-20">
          <img
            src="https://images.unsplash.com/photo-1451187580459-43490279c0fa"
            alt=""
            className="w-full h-full object-cover"
          />
        </div>
        {/* Grid Overlay */}
        <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.02)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.02)_1px,transparent_1px)] bg-[size:100px_100px]"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="inline-flex items-center gap-2 bg-white/5 border border-white/10 rounded-full px-4 py-1.5">
              <span className="w-2 h-2 rounded-full bg-[#00d4ff] animate-pulse"></span>
              <span className="text-sm text-gray-300 tracking-wide">Singapore-Based Studio</span>
            </div>

            <h1 className="text-4xl lg:text-5xl xl:text-[3.5rem] font-bold text-white leading-[1.2]">
              <span className="block">We build secure</span>
              <span className="block">
                <span className="bg-gradient-to-r from-[#00d4ff] to-[#0ea5e9] bg-clip-text text-transparent">
                  Blockchain
                </span>
                {' & '}
                <span className="bg-gradient-to-r from-[#ff6b35] to-[#ff2e63] bg-clip-text text-transparent">
                  AI products
                </span>
              </span>
              <span className="block text-gray-300 font-semibold">
                for startups and enterprises
              </span>
            </h1>

            <p className="text-lg text-gray-400 leading-relaxed max-w-md">
              Scalable products built on on-chain engineering, ML and AI — delivered from our Singapore studio.
            </p>

            <div className="flex flex-wrap gap-4">
              <Button
                onClick={scrollToServices}
                className="bg-white/10 hover:bg-white/20 text-white border border-white/20 px-8 py-3 rounded-lg transition-all duration-300"
              >
                Our Services
              </Button>
              <Button
                onClick={handleContact}
                className="bg-gradient-to-r from-[#ff6b35] to-[#ff2e63] hover:from-[#ff7b45] hover:to-[#ff3e73] text-white px-8 py-3 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl flex items-center gap-2"
              >
                Talk to an Expert <ArrowRight size={18} />
              </Button>
            </div>
          </div>

          {/* Right Content - Interactive dApp Interface */}
          <div className="relative">
            <div className="bg-gradient-to-br from-[#1a1f35] to-[#0f1420] rounded-2xl border border-white/10 shadow-2xl overflow-hidden backdrop-blur-md">
              {/* Tabs */}
              <div className="flex border-b border-white/10">
                <button
                  onClick={() => setActiveTab('auction')}
                  className={`flex-1 px-6 py-4 text-sm font-medium transition-all duration-300 ${
                    activeTab === 'auction'
                      ? 'bg-gradient-to-r from-[#ff6b35]/20 to-[#ff2e63]/20 text-white border-b-2 border-[#ff6b35]'
                      : 'text-gray-400 hover:text-white'
                  }`}
                >
                  AUCTION
                </button>
                <button
                  onClick={() => setActiveTab('staking')}
                  className={`flex-1 px-6 py-4 text-sm font-medium transition-all duration-300 ${
                    activeTab === 'staking'
                      ? 'bg-gradient-to-r from-[#ff6b35]/20 to-[#ff2e63]/20 text-white border-b-2 border-[#ff6b35]'
                      : 'text-gray-400 hover:text-white'
                  }`}
                >
                  STAKING
                </button>
                <button
                  onClick={() => setActiveTab('summary')}
                  className={`flex-1 px-6 py-4 text-sm font-medium transition-all duration-300 ${
                    activeTab === 'summary'
                      ? 'bg-gradient-to-r from-[#ff6b35]/20 to-[#ff2e63]/20 text-white border-b-2 border-[#ff6b35]'
                      : 'text-gray-400 hover:text-white'
                  }`}
                >
                  SUMMARY
                </button>
              </div>

              {/* Content */}
              <div className="p-6 space-y-6">
                {activeTab === 'auction' && (
                  <div className="space-y-4 animate-fade-in">
                    <div className="flex items-center justify-between">
                      <span className="text-gray-400 text-sm">Current Bid</span>
                      <span className="text-2xl font-bold text-white flex items-center gap-2">
                        <DollarSign size={20} className="text-[#ff6b35]" />
                        125,000
                      </span>
                    </div>
                    <div className="bg-white/5 rounded-lg p-4 space-y-2">
                      <div className="flex justify-between text-sm">
                        <span className="text-gray-400">Time Remaining</span>
                        <span className="text-white font-medium">2h 34m 12s</span>
                      </div>
                      <div className="flex justify-between text-sm">
                        <span className="text-gray-400">Total Bids</span>
                        <span className="text-white font-medium">47</span>
                      </div>
                    </div>
                    <Button className="w-full bg-gradient-to-r from-[#ff6b35] to-[#ff2e63] hover:from-[#ff7b45] hover:to-[#ff3e73] text-white py-3 rounded-lg">
                      Place Bid
                    </Button>
                  </div>
                )}

                {activeTab === 'staking' && (
                  <div className="space-y-4 animate-fade-in">
                    <div className="flex items-center justify-between">
                      <span className="text-gray-400 text-sm">APY</span>
                      <span className="text-2xl font-bold text-[#00d4ff] flex items-center gap-2">
                        <TrendingUp size={20} />
                        24.5%
                      </span>
                    </div>
                    <div className="bg-white/5 rounded-lg p-4 space-y-2">
                      <div className="flex justify-between text-sm">
                        <span className="text-gray-400">Your Stake</span>
                        <span className="text-white font-medium">50,000 TOKENS</span>
                      </div>
                      <div className="flex justify-between text-sm">
                        <span className="text-gray-400">Rewards Earned</span>
                        <span className="text-white font-medium">3,245 TOKENS</span>
                      </div>
                    </div>
                    <Button className="w-full bg-gradient-to-r from-[#00d4ff] to-[#0ea5e9] hover:from-[#10d4ff] hover:to-[#1ea5e9] text-white py-3 rounded-lg">
                      Stake Now
                    </Button>
                  </div>
                )}

                {activeTab === 'summary' && (
                  <div className="space-y-4 animate-fade-in">
                    <div className="grid grid-cols-2 gap-4">
                      <div className="bg-white/5 rounded-lg p-4">
                        <div className="text-gray-400 text-xs mb-1">Total Value Locked</div>
                        <div className="text-white text-xl font-bold">$2.5M</div>
                      </div>
                      <div className="bg-white/5 rounded-lg p-4">
                        <div className="text-gray-400 text-xs mb-1">Active Users</div>
                        <div className="text-white text-xl font-bold">1,247</div>
                      </div>
                      <div className="bg-white/5 rounded-lg p-4">
                        <div className="text-gray-400 text-xs mb-1">24h Volume</div>
                        <div className="text-white text-xl font-bold">$850K</div>
                      </div>
                      <div className="bg-white/5 rounded-lg p-4">
                        <div className="text-gray-400 text-xs mb-1">Transactions</div>
                        <div className="text-white text-xl font-bold">3,892</div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Decorative Elements */}
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-gradient-to-br from-[#ff6b35] to-[#ff2e63] rounded-full blur-3xl opacity-30 animate-pulse"></div>
            <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-gradient-to-br from-[#00d4ff] to-[#0ea5e9] rounded-full blur-3xl opacity-30 animate-pulse" style={{ animationDelay: '1s' }}></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;